var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashierCardBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 227,
    viewBox: "0 0 381 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3719_72240",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 381,
    height: 227
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3719_72240)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_3719_72240)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.70711,
    y: -12.3809,
    width: 114.427,
    height: 114.427,
    rx: 8.5,
    transform: "rotate(-45 7.70711 -12.3809)",
    stroke: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 277.121,
    y: 247.33,
    width: 83.7326,
    height: 112.427,
    rx: 7.5,
    transform: "rotate(-45 277.121 247.33)",
    stroke: "#F0F5FC",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 106.707,
    y: 185.809,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 106.707 185.809)",
    stroke: "#EAEAEA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -35.2078,
    y: 28,
    width: 294.982,
    height: 151.027,
    rx: 20,
    transform: "rotate(45 -35.2078 28)",
    fill: "#F4FAFF"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 57.7071,
    y: -14.3809,
    width: 114.427,
    height: 114.427,
    rx: 8.5,
    transform: "rotate(-45 57.7071 -14.3809)",
    stroke: "#DBDBDB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 106.707,
    y: 185.809,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 106.707 185.809)",
    stroke: "#EAEAEA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-43 85L106 85C112.627 85 118 90.3726 118 97V188C118 194.627 112.627 200 106 200H-43L-43 85Z",
    fill: "#FBFDFF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-42.5 85.5L106 85.5C112.351 85.5 117.5 90.6487 117.5 97V188C117.5 194.351 112.351 199.5 106 199.5H-42.5L-42.5 85.5Z",
    stroke: "#B2B9C0",
    strokeOpacity: 0.42
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 128.5,
    width: 13,
    height: 9,
    rx: 1.5,
    stroke: "#E4E5E5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 128.5,
    width: 13,
    height: 9,
    rx: 1.5,
    fill: "#EAF1FB",
    stroke: "#E4E5E5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 128.5,
    width: 13,
    height: 9,
    rx: 1.5,
    stroke: "#E4E5E5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 146.5,
    width: 13,
    height: 9,
    rx: 1.5,
    fill: "#EAF1FB",
    stroke: "#E4E5E5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 146.5,
    width: 13,
    height: 9,
    rx: 1.5,
    stroke: "#E4E5E5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 146.5,
    width: 13,
    height: 9,
    rx: 1.5,
    fill: "#EAF1FB",
    stroke: "#E4E5E5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 164.5,
    width: 13,
    height: 9,
    rx: 1.5,
    stroke: "#E4E5E5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 164.5,
    width: 13,
    height: 9,
    rx: 1.5,
    stroke: "#E4E5E5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 164.5,
    width: 13,
    height: 9,
    rx: 1.5,
    fill: "#EAF1FB",
    stroke: "#E4E5E5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 182.5,
    width: 13,
    height: 9,
    rx: 1.5,
    fill: "#EAF1FB",
    stroke: "#E4E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3719_72240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashierCardBackground);
export default __webpack_public_path__ + "static/media/cashier-card-background.0f0a30d9d9691dd756b420831f6d0d5a.svg";
export { ForwardRef as ReactComponent };